<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>钱包开关</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="币种开关" name="coin"></el-tab-pane>
        <el-tab-pane label="批量开关" name="batch"></el-tab-pane>
      </el-tabs>
      <switch-list v-if="activeTab === 'coin'"></switch-list>
      <batch-switch-list v-if="activeTab === 'batch'"></batch-switch-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import SwitchList from './components/list';
import BatchSwitchList from './components/batchList';

export default {
  name: 'WalletSwitch',
  components: {
    SwitchList,
    BatchSwitchList
  },
  data() {
    return {
      activeTab: 'coin'
    };
  }
};
</script>

<style lang="less" scoped></style>
